module.exports = {"gitCommit":"7817878","buildDate":"2025-07-04T01:54:07.210Z","context":"/qkr_mss"}


//////////////////
// WEBPACK FOOTER
// ./src/appConfig.json
// module id = 320
// module chunks = 0